import React, { useState } from "react"

const Tooltip = ({ text, textOnClick, offsetBubble = 'bottom-8', offsetBubblePointer = 'top-6', children, ...props }) => {
	const [isVisible, setIsVisible] = useState(false)
	const [tooltipClicked, setTooltipClicked] = useState(false)

	const handleTooltipClicked = () => {
		let timer

		setTooltipClicked(true)
		if (isVisible) {
			timer = setTimeout(() => {
				setIsVisible(false);
			}, 2000); // 2 seconds before fading out
		}
		
		return () => clearTimeout(timer); // Cleanup when unmounting or re-hovering
	}

	return (
		<div
			className="relative flex items-center justify-center"
			onMouseEnter={() => { setTooltipClicked(false); setIsVisible(true) }}
			onMouseLeave={() => setIsVisible(false)}
			{...props}
		>
			<div className={`${props.className}`} onClick={()=> handleTooltipClicked()}>
				{children}
			</div>

			<div
				className={`absolute ${offsetBubble} left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xxs py-1 px-2 whitespace-nowrap rounded-md shadow-lg text-center transition-opacity duration-300 pointer-events-none ${
				isVisible ? "opacity-100" : "opacity-0"
				}`}
			>
				<div className={`z-0 absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-800 rotate-45 ${offsetBubblePointer}`}></div>
				<span className="relative">{!tooltipClicked ? text : textOnClick ?? text}</span>
				{/* Snapping Diamond Speech Bubble */}
			</div>
		</div>
	);
};

export default Tooltip
